export const DEFAULT_SCHEMA_NAME = "Schema";
